<template>
  <div>
    <md-card>

      <md-card-content>

        <md-card-header>
          <div class="md-title">誤字脱字を報告する</div>
        </md-card-header>

        <md-input-container>
          <label>セット名</label>
          <md-input v-model="setName" disabled></md-input>
        </md-input-container>

        <div class="field-group">
          <md-input-container>
            <label for="endHour">フィガー</label>
            <md-select name="figureSummary" id="figureSummary" v-model="figureNumber">
              <md-option v-for="(figure, index) in set.figures" :key="index" :value="index">{{ getFigureSummary(figure) }}</md-option>
            </md-select>
          </md-input-container>
        </div>

        <div class="field-group">
          <md-input-container>
            <label for="movement">ムーブメント</label>
            <md-select name="movement" id="movement" v-model="movement">
              <md-option v-for="(mv, index) in figure.movements" v-show="mv.summary" :key="index" :value="mv.summary">{{ mv.summary }}</md-option>
            </md-select>
          </md-input-container>
        </div>

        <md-input-container
          md-clearable
          v-show="!commentError">
          <label>コメント</label>
          <md-textarea v-model="description"></md-textarea>
        </md-input-container>
        <md-input-container
          md-clearable
          v-show="commentError"
          class="md-input-invalid">
          <label>コメント</label>
          <md-textarea v-model="description"></md-textarea>
        <span
          class="md-error"
          v-model="commentError">{{ commentError }}</span>
        </md-input-container>

        <md-button id="addReport" class="md-raised md-primary" @click="addReport('dialog5')">報告する</md-button>

      </md-card-content>

    </md-card>

    <md-divider></md-divider>

    <md-table>
      <md-table-header>
        <md-table-row>
          <md-table-head>セット</md-table-head>
          <md-table-head md-numeric>フィガー</md-table-head>
          <md-table-head md-numeric>ムーブメント</md-table-head>
          <md-table-head md-numeric><md-icon>message</md-icon> コメント</md-table-head>
        </md-table-row>
      </md-table-header>

      <md-table-body>
        <md-table-row
          v-for="(report, index) in reports"
          :key="index">
          <md-table-cell>{{ report.setName }}</md-table-cell>
          <md-table-cell md-numeric>{{ report.figureSummary }}</md-table-cell>
          <md-table-cell>{{ report.movement }}</md-table-cell>
          <md-table-cell>{{ report.description }}
            <md-chip
              v-if="report.state === 'closed'"
              key="stateClosed">対応済み</md-chip>
            <md-chip
              v-else
              class="md-primary"
              key="statePending">処理中</md-chip>
          </md-table-cell>
        </md-table-row>
      </md-table-body>
    </md-table>

    <md-dialog-alert
      :md-content="dialog.content"
      :md-ok-text="dialog.ok"
      @open="onOpen"
      @close="onClose"
      ref="dialog3">
    </md-dialog-alert>

  </div>
</template>

<script>
import db from '../db'

export default {
  name: 'reports',
  data () {
    return {
      setName: this.$route.params.setName,
      set: {},
      figure: {},
      figureNumber: this.$route.params.figureNumber !== undefined ? this.$route.params.figureNumber : 0,
      figureSummary: '',
      movement: this.$route.params.movement,
      description: '',
      commentError: '',
      reports: [],
      dialog: {
        content: 'コメントを追加しました',
        ok: '閉じる'
      },
      error: null
    }
  },
  firebase: {
    reports: db.ref('/reports').orderByChild('index')
  },
  created () {
    this.refreashData()
  },
  watch: {
    '$route': 'refreashData',
    'figureNumber': 'resetMovement'
  },
  beforeRouteEnter: (to, from, next) => {
    db.ref('/sets/' + to.params.setName).once('value').then(function (set) {
      next((vm) => {
        vm.set = set.val()
        vm.figure = vm.set.figures[vm.figureNumber]
        vm.figureSummary = vm.getFigureSummary(vm.set.figures[vm.figureNumber])
      })
    })
  },
  methods: {
    refreashData () {
      let self = this
      db.ref('/sets/' + this.setName).once('value').then(function (set) {
        self.set = set.val()
        self.figure = self.set.figures[self.figureNumber]
        self.figureSummary = self.getFigureSummary(self.set.figures[self.figureNumber])
      })
    },
    getFigureSummary (figure) {
      return '#' + figure.order + ': ' + figure.summary + ' (' + figure.rythmn + ')'
    },
    resetMovement () {
      this.figure = this.set.figures[this.figureNumber]
      this.figureSummary = this.getFigureSummary(this.figure)
    },
    addReport () {
      if (this.description === '') {
        this.commentError = 'コメントが入力されていません'
        return
      }
      this.commentError = ''

      let self = this
      let newReportRef = db.ref('/reports').push()
      // console.log(this.setName, this.figureS, this.movement, this.description)

      let movement = this.movement ? this.movement : '未記入'

      newReportRef.set({
        id: newReportRef.key,
        index: Date.parse(new Date()) * -1,
        setName: this.setName,
        figureSummary: this.figureSummary,
        movement: movement,
        state: 'pending',
        description: this.description
      }).then(function () {
        self.openDialog('dialog3')
        self.description = ''
      })
    },
    openDialog (ref) {
      this.$refs[ref].open()
    },
    closeDialog (ref) {
    },
    onOpen () {
    },
    onClose (type) {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

h2 {
  margin-top: 48px;
}

a {
  color: #42b983;
}

.md-divider {
  margin: 32px 0 8px 0;
}
</style>



// WEBPACK FOOTER //
// Report.vue?44b2fd1a